import { AjaxRetailers } from './Modules/AjaxRetailers.js';
import { ButtonManager } from './Modules/ButtonManager.js';
import { EmailValidation } from './Modules/EmailValidation.js';
import { FormValidation } from './Modules/FormValidation.js';
import { GoogleTagManager } from './Modules/GoogleTagManager.js';
import { PlaceHolderManager } from './Modules/PlaceHolderManager.js';
import { Products } from './Modules/Products.js';
import { RegistrationReferrer } from './Modules/RegistrationReferrer.js';
import { UserProfile } from './Modules/UserProfile.js';

export const App = {

  init: function () {
    GoogleTagManager.requestDataAndPush();
    FormValidation.init();
    PlaceHolderManager.init();
    RegistrationReferrer.init();
    EmailValidation.init();
    ButtonManager.init();
    UserProfile.init();
    Products.init();

    App.initializeRetailerLogoCarousel();
    App.initializeRetailerList();
    App.initializeUItoTop();
    App.initializeSmoothAnchors();
    App.initializeDropdownHover();
    App.initializeNavbarToggleIcon();
    App.initializeDisableEmptyLinks();
    App.initializeCenterKeyVisual();
    App.initializeDynamicRetailerBoxHeight();
    App.initializeResponsiveTables();
    App.initializeTogglePasswordIcon();
    App.initializeRetailerInlineLoading();
  },

  initializeRetailerLogoCarousel: function () {
    // owl carousel for retailer logos
    if ($('.owl-carousel-5').length > 0) {
      // Owl Carousel
      $('.owl-carousel-5').owlCarousel({
        items: 5,
        itemsDesktop: [1200, 4], //5 items between 1000px and 901px
        itemsDesktopSmall: [992, 3], // betweem 900px and 601px
        itemsTablet: [650, 2], //2 items between 600 and 0
        itemsMobile: [450, 1], // itemsMobile disabled - inherit from itemsTablet option
        lazyLoad: true,
        pagination: false,
        navigation: true,
        navigationText: false
        //autoPlay: 10000,
        //stopOnHover: true
      });
    }
  },

  initializeRetailerList: function () {
    // init ajax retailer
    if ($('#ulSorList').length > 0) {
      AjaxRetailers.init();
    }
  },

  initializeUItoTop: function () {
    // Scroll to top
    const toTopBtn = document.getElementById('toTop');

    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        toTopBtn.classList.add('show');
      } else {
        toTopBtn.classList.remove('show');
      }
    });

    toTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  },

  initializeSmoothAnchors: function () {
    document.querySelectorAll('a.anchor').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          const offset = 40;
          const targetY = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({top: targetY, behavior: 'smooth'});
        }
      });
    });
  },

  initializeDropdownHover: function () {
    function setupDropdownBehavior () {
      const $dropdown = $('.navbar-wp .dropdown');
      const $dropdownToggle = $('.navbar-wp .dropdown-toggle');
      const isDesktop = $(window).width() > 992;

      $dropdown.off('.desktopDropdown');
      $dropdownToggle.off('.desktopDropdown');

      if (isDesktop) {
        $dropdown
          .on('mouseenter.desktopDropdown', function () {
            $(this).addClass('open');
          })
          .on('mouseleave.desktopDropdown', function () {
            $(this).removeClass('open');
          });

        $dropdownToggle.on('click.desktopDropdown', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
    }

    setupDropdownBehavior();

    $(window).on('resize', setupDropdownBehavior);
  },

  initializeNavbarToggleIcon: function () {
    const $btn = $('.navbar-toggle');

    $btn.on('click', function () {
      const $this = $(this);
      $this.toggleClass('collapsed');
    });
  },

  initializeDisableEmptyLinks: function () {
    // Disable Empty Links
    $('[href=\'#\']').on('click', function (event) {
      event.preventDefault();
    });
  },

  initializeCenterKeyVisual: function () {
    $('.key-visual').each(function () {
      var $this = $(this);
      $this.on('load', function () {
        App.centerKeyVisual($(this));
      });
      App.centerKeyVisual($this);
    });
  },

  centerKeyVisual: function ($img) {
    var imageMaxWidth = $img.data('imgMaxWidth');

    if ($(document).width() <= imageMaxWidth) {
      $img.css({
        'position': 'absolute',
        'left': '50%',
        'margin-left': ($img.width() / 2) * -1
      });
    } else {
      $img.removeAttr('style');
    }
  },

  initializeDynamicRetailerBoxHeight: function ($img) {
    $('.matchheight .wp-block').matchHeight();
  },

  initializeResponsiveTables: function () {
    $('.table-responsive').closest('.table-container').addClass('table-overflow');
  },


  initializeTogglePasswordIcon: function () {
    document.querySelectorAll('.togglePassword').forEach(icon => {
      icon.addEventListener('click', function () {
        const container = this.parentElement;
        const passwordField = container.querySelector('.password');
        const showIcon = container.querySelector('.fa-eye');
        const hideIcon = container.querySelector('.fa-eye-slash');

        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          showIcon.classList.add('hide');
          hideIcon.classList.remove('hide');
        } else {
          passwordField.type = 'password';
          showIcon.classList.remove('hide');
          hideIcon.classList.add('hide');
        }
      });
    });
  },


  initializeRetailerInlineLoading: function () {
    var $loader = $('#retailer-list-loading');
    var $content = $('#retailer-list-content');

    if (!$loader.length || !$content.length) {
      return;
    }

    function showLoading () {
      $loader.addClass('is-visible');
      $content.addClass('is-hidden');
    }

    //Such-Formular
    $(document).on('submit', 'form.shop-search', function () {
      showLoading();
    });

    //Sortier-Links
    $(document).on('click', 'a.sort-link', function () {
      showLoading();
    });

    //Kategorie-Filter
    $(document).on('click', '#ulFilterMenu a.filter', function () {
      showLoading();
    });

    //Reset-Link
    $(document).on('click', 'a.retailer-reset', function () {
      showLoading();
    });

    //Loader zurücksetzen
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        $loader.removeClass('is-visible');
        $content.removeClass('is-hidden');
      }
    });
  },
};

$(function () {
  App.init();
});
